<template>
    <div class="app">
        <div id="main" v-if="isMainShow">
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">消费列表</span>
        </header>
        <div class="content">
            <div class="blank"></div>
            <div class="noData" v-if="!haveData">
                <img src="../../assets/images/search.png" alt="">
                <span>暂无任何消费记录</span>
            </div>
            <div v-if="haveData">
                <mt-navbar class="page-part" v-model="selected">
                    <mt-tab-item id="1">全部</mt-tab-item>
                    <mt-tab-item id="2">今日</mt-tab-item>
                    <mt-tab-item id="3">本周</mt-tab-item>
                    <mt-tab-item id="4">本月</mt-tab-item>
                </mt-navbar>
                <mt-tab-container v-model="selected">
                    <mt-tab-container-item id="1">
                        <div class="data-section">
                            <a href="javascript:;" class="data-today">{{ timeDate }}</a>
                            <a href="javascript:;" @click="goDatePage" class="data-search"><span class="iconfont icon-calendar">自定义查询</span></a>
                        </div>
                        <ul class="all" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" >
                            <li class="itemList" v-for="(cardOrder, key) in filterSelectedCardList" :key="key">
                                <span class="shopName">{{ cardOrder.name }}</span>
                                <div>
                                    <span>￥{{formatMoney(cardOrder && cardOrder.payAmount / 100)}}</span>
                                </div>
                                <div>
                                    <span>{{ cardOrder.orderTime | moment('YYYY年MM月DD日 HH:mm') }}</span>
                                </div>  
                                <div :class="(cardOrder.orderStatus == 2) ? 'warnStyle' : ''">{{ getOrderStatusText(cardOrder.orderStatus) }}</div>
                            </li>
                        </ul>
                    </mt-tab-container-item>
                    <mt-tab-container-item id="2">
                        <div class="data-section">
                            <a href="javascript:;" class="data-today">{{ timeDate }}</a>
                            <a href="javascript:;" @click="goDatePage" class="data-search"><span class="iconfont icon-calendar">自定义查询</span></a>
                        </div>
                        <div v-if="haveData1">
                        <ul class="all" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" >
                            <li class="itemList" v-for="(cardOrder, key) in filterSelectedCardList" :key="key">
                                <span class="shopName">{{ cardOrder.name }}</span>
                                <div>
                                    <span>￥{{formatMoney(cardOrder && cardOrder.payAmount / 100)}}</span>
                                </div>
                                <div>
                                    <span>{{ cardOrder.orderTime | moment('YYYY年MM月DD日 HH:mm') }}</span>
                                </div>  
                                <div :class="(cardOrder.orderStatus == 2) ? 'warnStyle' : ''">{{ getOrderStatusText(cardOrder.orderStatus) }}</div>
                            </li>
                        </ul>
                        </div>
                        <div class="noData1" v-else>
                            <img src="../../assets/images/search.png" alt="">
                            <span>今日暂无任何消费记录</span>
                        </div>
                    </mt-tab-container-item>
                    <mt-tab-container-item id="3">
                        <div class="data-section">
                            <a href="javascript:;" class="data-today">{{ timeDate }}</a>
                            <a href="javascript:;" @click="goDatePage" class="data-search"><span class="iconfont icon-calendar">自定义查询</span></a>
                        </div>
                        <div v-if="haveData1">
                        <ul class="all" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" >
                            <li class="itemList" v-for="(cardOrder, key) in filterSelectedCardList" :key="key">
                                <span class="shopName">{{ cardOrder.name }}</span>
                                <div>
                                    <span>￥{{formatMoney(cardOrder && cardOrder.payAmount / 100)}}</span>
                                </div>
                                <div>
                                    <span>{{ cardOrder.orderTime | moment('YYYY年MM月DD日 HH:mm') }}</span>
                                </div>  
                                <div :class="(cardOrder.orderStatus == 2) ? 'warnStyle' : ''">{{ getOrderStatusText(cardOrder.orderStatus) }}</div>
                            </li>
                        </ul>
                        </div>
                        <div class="noData1" v-else>
                            <img src="../../assets/images/search.png" alt="">
                            <span>本周暂无任何消费记录</span>
                        </div>
                    </mt-tab-container-item>
                    <mt-tab-container-item id="4">
                        <div class="data-section">
                            <a href="javascript:;" class="data-today">{{ timeDate }}</a>
                            <a href="javascript:;" @click="goDatePage" class="data-search"><span class="iconfont icon-calendar">自定义查询</span></a>
                        </div>
                        <div v-if="haveData1">
                        <ul class="all" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" >
                            <li class="itemList" v-for="(cardOrder, key) in filterSelectedCardList" :key="key">
                                <span class="shopName">{{ cardOrder.name }}</span>
                                <div>
                                    <span>￥{{formatMoney(cardOrder && cardOrder.payAmount / 100)}}</span>
                                </div>
                                <div>
                                    <span>{{ cardOrder.orderTime | moment('YYYY年MM月DD日 HH:mm') }}</span>
                                </div>  
                                <div :class="(cardOrder.orderStatus == 2) ? 'warnStyle' : ''">{{ getOrderStatusText(cardOrder.orderStatus) }}</div>
                            </li>
                        </ul>
                        </div>
                        <div class="noData1" v-else>
                            <img src="../../assets/images/search.png" alt="">
                            <span>本月暂无任何消费记录</span>
                        </div>
                    </mt-tab-container-item>
                    <mt-tab-container-item id="5">
                        <div class="data-section">
                            <a href="javascript:;" class="data-today">{{ timeDate }}</a>
                            <a href="javascript:;" @click="goDatePage" class="data-search"><span class="iconfont icon-calendar">自定义查询</span></a>
                        </div>
                        <div v-if="haveData1">
                        <ul class="all" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" >
                            <li class="itemList" v-for="(cardOrder, key) in filterSelectedCardList" :key="key">
                                <span class="shopName">{{ cardOrder.name }}</span>
                                <div>
                                    <span>￥{{formatMoney(cardOrder && cardOrder.payAmount / 100)}}</span>
                                </div>
                                <div>
                                    <span>{{ cardOrder.orderTime | moment('YYYY年MM月DD日 HH:mm') }}</span>
                                </div>  
                                <div :class="(cardOrder.orderStatus == 2) ? 'warnStyle' : ''">{{ getOrderStatusText(cardOrder.orderStatus) }}</div>
                            </li>
                        </ul>
                        </div>
                        <div class="noData1" v-else>
                            <img src="../../assets/images/search.png" alt="">
                            <span>这段时间暂无任何消费记录</span>
                        </div>
                    </mt-tab-container-item>
                </mt-tab-container>
            </div>
        </div>
    </div>
    <div v-else>
        <header>
            <i class="el-icon-arrow-left"  @click="$router.go(-1)"></i>
            <span class="pageTitle">自定义查询</span>
        </header>
        <div class="content">
            <div class="blank2"></div>
            <div class="dateBox">
                <mt-cell @click.native="open('picker1')" title="开始时间" is-link>
                    <span style="margin-right: 100px">{{ value1 | moment('YYYY年MM月DD日')  }}</span>
                </mt-cell>
                <mt-cell @click.native="open('picker2')" title="结束时间" is-link>
                    <span style="margin-right: 100px">{{ value2 | moment('YYYY年MM月DD日')  }}</span>
                </mt-cell>
                <mt-button class="enter" size="large" @click="enter">确&nbsp;&nbsp;&nbsp;&nbsp;认</mt-button>
            </div>
            <mt-datetime-picker
                ref="picker1"
                v-model="value1"
                type="date"
                year-format="{value} 年"
                month-format="{value} 月"
                date-format="{value} 日"
                @confirm="handleChange1">
            </mt-datetime-picker>
            <mt-datetime-picker
                ref="picker2"
                v-model="value2"
                type="date"
                year-format="{value} 年"
                month-format="{value} 月"
                date-format="{value} 日"
                @confirm="handleChange2">
            </mt-datetime-picker>
        </div>
    </div>
    </div>
</template>
<script>
import bottom from "../footerTo/bottom"
import { Cell, DatetimePicker, MessageBox, Popup, Toast, Indicator, Radio, Navbar, TabItem, TabContainer, TabContainerItem } from "mint-ui"
import { showAllOrderListAction } from '../../assets/js/api'
import moment from 'moment'
import { MoneyTowPoint } from '@/assets/js/utilities'

export default {
    name: 'xiaofeiList',
    data() {
        return {  
            haveData1:false,
            isFront:false, 
            isVip:false,
            haveRead:false,
            selected:'1',
            beginIdx:0,            // 分页开始值
            num:0,                 // 分页次数
            loading:true,          // 是否加载 
            cardOrderList:[],      // 会员卡历史订单信息 
            haveData:false,        // 是否有数据
            timeDate: '全部查询',
            isMainShow: true,
            value1: null,  
            value2: null,
        };
    },
    computed: {
        filterSelectedCardList: function () {
            let filterString = ''
            if (this.selected == '2') {
                var todayStr = moment(new Date()).format('YYYY年MM月DD日')
                this.timeDate = todayStr + ' - ' + todayStr
                filterString = 'days'
            } else if (this.selected == '3') {
                this.timeDate = moment().startOf('week').format('YYYY年MM月DD日') + ' - ' + moment(new Date()).format('YYYY年MM月DD日')
                filterString = 'weeks'
            } else if (this.selected == '4') {
                this.timeDate = moment().startOf('month').format('YYYY年MM月DD日') + ' - ' + moment(new Date()).format('YYYY年MM月DD日')
                filterString = 'months'
            }
            if (this.selected == '1') {
                this.haveData1 = this.haveData
                this.timeDate = '全部查询'
                return this.cardOrderList
            } else if (this.selected == '5') {
                let filterCardList = []
                this.cardOrderList.forEach(element => {
                    if (moment(element.orderTime).isBetween(this.value1, this.value2, 'day', '[]')) {
                        filterCardList.push(element)
                    }
                })
                this.haveData1 = (filterCardList.length > 0)
                this.timeDate = moment(this.value1).format('YYYY年MM月DD日') + ' - ' + moment(this.value2).format('YYYY年MM月DD日')
                
                return filterCardList
            } else {
                let filterCardList = []
                this.cardOrderList.forEach(element => {
                    if (moment().isSame(element.orderTime, filterString)) {
                        filterCardList.push(element)
                    }
                })
                this.haveData1 = (filterCardList.length > 0)
                return filterCardList
            }
        },
    },
    components: {},
    methods: {
    formatMoney (s) {
      if (!s) {
        s = 0
      }
      return MoneyTowPoint(s)
    },
    open(picker) {
        this.$refs[picker].open();
      },
        // 跳转到日期选择页
        goDatePage(){
            this.value1 = new Date()
            this.value2 = new Date()
            this.isMainShow = false
        },
        // 跳转到订单详情页
        goOrderDetailsPage(index)
        {
            var cardInfo = this.cardOrderList[index];
            cardInfo.sid = this.$store.state.selectedCardInfo.sid;
            this.$store.commit("selectedOrderInfo",cardInfo);
            var type     = cardInfo.orderStatus;
            console.log('type',type);
            if (type == 1)
            {
                console.log('jinlaile');
                this.$router.push({ name:"payDetail" });
            }
            
        },
        loadMore()
        {
            this.getCardOrderList();
        },
        //获取单张卡的订单记录
        getCardOrderList()
        {
            var orderBy = 0;                                        // 按时间降序排序
            var sid     = this.$store.state.selectedCardInfo.sid;
            var cid     = this.$store.state.selectedCardInfo.cid;
            var maxRows = 10 ;
            if (this.num !== 0)
            {
                this.beginIdx = maxRows*this.num;
            }
            console.log('num',this.num);
            console.log('beginIdx',this.beginIdx);
            this.num ++;

            showAllOrderListAction().then ( res => {
                console.log('res111',res);
                if (res.s == 0)
                {
                    this.loading = false              // 执行加载             
                    if (this.cardOrderList)
                    {
                        // 存入新获取的商品列表数据
                        res.list.forEach((v,i)=> { this.cardOrderList.push(v); })
                    }
                    else
                    {
                        this.cardOrderList = res.list;
                    }
                    this.haveData = (this.cardOrderList.length != 0)
                    this.haveData1 = this.haveData
                    this.filterCardList = this.cardOrderList
                    this.$store.commit("cardOrderListInfo",this.cardOrderList);

                    //this.messageList = res.MessageList;
                    console.log("cardOrderList",this.cardOrderList);

                    if (res.list.length < maxRows)
                    {
                        this.loading = true;
                        //return false;
                    }
                }
                else if (res.s == 1010)
                {
                    this.loading = true;
                    if (this.cardOrderList.length == 0)
                    {
                        this.haveData = false;
                    }
                }
            });
        },
        getOrderStatusText (orderStatus) {
            if (orderStatus == 0) {
                return '已完成'
            } else if (orderStatus == 1) {
                return '退款成功'
            } else if (orderStatus == 2) {
                return '待付款'
            } else {
                return ''
            }
        },
    // Page2
      betweenOverMonth () {
          var betweenDay = moment(this.value2).diff(this.value1, 'days')
          
          if (betweenDay < 0) {
              MessageBox.alert("开始时间不能大于结束时间")
              return true
          } else if (betweenDay > 30) {
              MessageBox.alert("查询间隔时间超过一个月")
              return true
          }
          return false
      },
      handleChange1(value) {
        this.value1 = value
      },
      handleChange2(value) {
        this.value2 = value
      },
        //确定日期
        enter(){
            if (!this.betweenOverMonth()) {
                this.isMainShow = true
                this.selected = '5'
            }
        }
    },
    mounted()
    {
        this.getCardOrderList();
    },       
};
</script>

<style scoped>
.app {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
}
header {
  height: 1.5rem;
  width: 100%;
  background-image: linear-gradient(-134deg, #299EAD 0%, #299EAD 100%);
  position: fixed;
  z-index: 1;
}
.blank {
  height: 1.5rem;
  width: 100%;
}
.pageTitle {
  font-size: 0.5rem;
  text-align: center;
  color: white;
  position: absolute;
  top: 50%;
  left: 38%;
  transform: translateY(-50%);
}
.el-icon-arrow-left {
  font-size: 0.7rem;
  color: white;
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
}
.content {
  position: absolute;
  flex: 1;
  height: 100%;
  width: 100%;
  background-color: rgba(241, 241, 241, 1);
}
.page-part{
    font-size: 0.42rem;
    font-weight: 600;
    color: rgba(153, 153, 153, 1);
}
.mint-tab-container-item{
    background-color: #fff;
}
.noData{
    width: 100%;
    height: 84%;
    text-align: center;
    position: relative;
}
.noData :nth-child(1){
    width: 2.42rem;
    height: 2.16rem;
    position: absolute;
    top: 1.67rem;
    left: 3.75rem;
}
.noData :nth-child(2){
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 4.68rem;
    left: 3.5rem;
}
/*data-section*/
.data-section{
	position: relative;
	width:100vw;
	height:1.39rem;
	text-decoration: none;
	background-color: rgb(255,255,255);
}	
.data-section::before{
	content: '';
	position: absolute;
	bottom:0;
	right:0.28rem;
	left:0.28rem;
	height:0.01rem;
	background-color:#dcdcdc;
}
.data-section a,.data-section h2{
	position: relative;
	display: block;
	height:100%;
	overflow: hidden;
	font-size: .44rem;
	font-family: "方正黑体简体";
	text-decoration: none;
	line-height: 1.39rem;
	text-align: center;
}
.data-section a{
	font-size:0.39rem;
	color:#969696;
}

.data-section a.data-today{
	float:left;
	padding-left:0.28rem;
}
.data-section a.data-search{
	float:right;
	padding-right:0.28rem;
	text-align: right;
}
.search{
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 0.53rem;
    right: 0rem;
}

.calendar {
  width: 2.8rem;
  height: 0.74rem;
  position: absolute;
}

.calendar span {
  display: block;
  text-align: center;
  font-size: 0.37rem;
}

.mint-navbar .mint-tab-item.is-selected{
    border-bottom: 0.15rem solid #FF5252;
    color: #FF5252;
    margin-bottom: -3px;
}
.itemList{
    width: 100%;
    height: 2.32rem;
    line-height: 0.68rem;
    position: relative;
    border-bottom: 0.01rem solid #FFFFFF;
}
.itemList div :nth-child(1){
    font-size: 0.37rem;
    margin-left: 0.53rem; 
    color: rgba(0, 0, 0, 0.7);   
}
.itemList div:nth-child(2) :nth-child(2){
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);  
    position: absolute;
    top: 0.75rem;
    left: 2.5rem;
}
.itemList div:nth-child(2) :nth-child(3){
    font-size: 0.37rem;
    margin-left: 0.53rem; 
    color: rgba(0, 0, 0, 0.5);  
    position: absolute;
    top: 0.75rem;
    left: 5.26rem; 
}
.itemList div:nth-child(3) :nth-child(2){
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);  
    position: absolute;
    top: 1.42rem;
    left: 2.5rem;
}
.itemList div:last-child{
    position: absolute;
    top: 0.4rem;
    right: 0.29rem;
}
.shopName{
    font-size: 0.47rem;
    color: rgba(0, 0, 0, 0.7);
    margin-left: 0.53rem;    
}

.noData1{
    width: 100%;
    height: 5.58rem;
    text-align: center;
    position: relative;
}
.noData1 :nth-child(1){
    width: 2.42rem;
    height: 2.16rem;
    position: absolute;
    top: 1.27rem;
    left: 3.75rem;
}
.noData1 :nth-child(2){
    font-size: 0.37rem;
    color: rgba(0, 0, 0, 0.5);
    position: absolute;
    top: 3.68rem;
    left: 3rem;
}
.warnStyle {
    color: #FF5252;
}
/* page2 */
.blank2 {
  height: 2.03rem;
  width: 100%;
}
.enter{
    font-size: 0.53rem;
    text-align: center;
    background-color: #299EAD;
    color: white;
    margin: 0.53rem auto;
    width: 80%;
}

</style>



// WEBPACK FOOTER //
// src/components/mine/xiaofeiList.vue